import { render, staticRenderFns } from "./ApDetail.vue?vue&type=template&id=48c5f0f2&"
import script from "./ApDetail.vue?vue&type=script&lang=js&"
export * from "./ApDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApDetail.vue"
export default component.exports